import { SurveyPoint } from './survey-point';

export interface CorrosionMonitoringLocation {
  id: string;
  fileId: string;
  label: string;
  status: string;
  location: Location;
  measurements: Measurement[];
  isCustom?: boolean;
}

export interface Location {
  left: number;
  top: number;
  width?: number;
  height?: number;
}

export interface Measurement {
  id: string;
  idValue: string;
  value: number;
  previousValue: number;
  status: string;
  serialNumber: string;
  comment: string;
  unitOfMeasurement: string;
  isCustom: boolean;
}

const convertToCorrosionMonitoringLocation = (suveryPoint: SurveyPoint, fileId: string): CorrosionMonitoringLocation => ({
  id: suveryPoint.id,
  fileId,
  label: suveryPoint.label,
  status: suveryPoint.measurementStatus,
  measurements: suveryPoint.ids.map(measurement => ({
    id: measurement.measurementPointId ? measurement.measurementPointId : null, // Empty string is not a valid UUID.
    idValue: measurement.id,
    value: measurement.measurement,
    previousValue: measurement.previousMeasurement, // This value is ignored by the backend
    status: measurement.status,
    serialNumber: measurement.serialNumber,
    comment: measurement.comment,
    unitOfMeasurement: measurement.unitOfMeasurement,
    isCustom: measurement.isCustom, // This value is ignored by the backend
  })),
  location: {
    left: suveryPoint.location.left,
    top: suveryPoint.location.top,
  },
});

const convertToSurveyPoint = (corrosionMonitoringLocation: CorrosionMonitoringLocation): SurveyPoint => ({
  id: corrosionMonitoringLocation.id,
  label: corrosionMonitoringLocation.label,
  measurementStatus: corrosionMonitoringLocation.status,
  isCustom: corrosionMonitoringLocation.isCustom,
  location: {
    left: corrosionMonitoringLocation.location.left,
    top: corrosionMonitoringLocation.location.top,
    width: corrosionMonitoringLocation.location.width,
    height: corrosionMonitoringLocation.location.height,
  },
  ids: corrosionMonitoringLocation.measurements.map(measurement => ({
    measurementPointId: measurement.id,
    id: measurement.idValue,
    measurement: measurement.value,
    previousMeasurement: measurement.previousValue,
    status: measurement.status,
    serialNumber: measurement.serialNumber,
    comment: measurement.comment,
    unitOfMeasurement: measurement.unitOfMeasurement,
    isCustom: measurement.isCustom,
    latitude: undefined,
    longitude: undefined,
  })),
});

export { convertToCorrosionMonitoringLocation, convertToSurveyPoint };
